import SocialSharing from "th/socialSharing";

export { SocialSharing };

customElements.define(
  "th-social-sharing",
  SocialSharing.CustomElementConstructor
);
